import React, { useEffect, useState } from "react";
import { Timeline } from "primereact/timeline";
import axios from "axios";
import "primereact/resources/themes/saga-blue/theme.css"; // or any other theme you prefer
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../App.css"; // Ensure you import your custom CSS
import LeadDbService from "../Services/LeadDbService";

const LeadNotesHistory = ({ docId }) => {
  console.log(`lead${docId}`);
  const [events, setEvents] = useState([]);

  // useEffect(() => {
  //   const fetchLeadHistory = async () => {
  //     try {
  //       const response = await axios.get(
  //         `https://value-realitty-backend-665385455484.asia-south1.run.app/api/v1/getLeadHistoryByDocId?docId=${docId}`
  //       );
  //       const history = response.data.history.map((item) => ({
  //         log: item.log,
  //         timestamp: new Date(item.timestamp).toLocaleString(),
  //       }));
  //       setEvents(history);
  //     } catch (error) {
  //       console.error("Error fetching lead history:", error);
  //     }
  //   };

  //   fetchLeadHistory();
  // }, [docId]);

  useEffect(() => {
    const fetchLeadNotesHistory = async () => {
      try {
        const response = await LeadDbService.fetchLeadNotesHistoryByDocId(
          docId
        );
        const history = response.data.history.map((item) => ({
          log: item.log,
          timestamp: item.timestamp
        }));
        setEvents(history);
      } catch (error) {
        console.error("Error fetching lead history:", error);
      }
    };

    fetchLeadNotesHistory();
  }, [docId]);
  return (
    <div className="bg-white shadow-md rounded w-full py-4 h-72 xl:h-[260px] 3xl:h-[316px] 4xl:h-[465px] ">
      <div className="text-2xl font-bold px-5">Lead Notes History</div>
      <div className="w-full h-72 4xl:h-[265px] xl:h-40 2xl:h-48 overflow-y-auto custom-scrollbar ">
        <Timeline
          className="px-10 xl:px-1 mt-6"
          value={events}
          opposite={(item) => (
            <small className="text-color-secondary text-xl font-semibold w-full  xl:text-base">
              {item.timestamp}
            </small>
          )}
          content={(item) => (
            <small className="text-color-secondary text-xl font-semibold  xl:text-base">
              {item.log}
            </small>
          )}
          marker={(item) => (
            <span
              className="custom-marker"
              style={{ borderColor: "#399E79", borderWidth: "3px" }}
            ></span>
          )}
        />
      </div>
    </div>
  );
};

export default LeadNotesHistory;
